<template>
    <div
        ref="rootElement"
        data-component="AmsStickyContainer"
        class="border-t-0 rounded-b-10 border border-white sticky bg-white top-[-1px] transition-all screen-m:rounded-10 screen-m:border-wildsand screen-m:border"
        :class="{
            'border-wildsand shadow screen-m:rounded-t-none z-popup': isSticking,
            '!static': rootElementPosition === null,
            '-translate-y-full': !isVisible && !isScreenM,
        }"
    >
        <slot />
    </div>
</template>

<script lang="ts" setup>
import { screenSizeDetection } from '@sunrise/shared'
import { onMounted, onUnmounted, ref, watch } from 'vue'

const props = defineProps<{
    mobileVisibilityThreshold?: number
}>()

const emit = defineEmits<{
    (e: 'update:sticking', event: boolean): void
}>()

const { isScreenM } = screenSizeDetection()

const rootElement = ref<HTMLElement | null>(null)
const isVisible = ref(true)
const isSticking = ref(false)
let rootElementPosition: number | null = null
let previousScrollY = 0

watch(isSticking, (isSticking) => {
    emit('update:sticking', isSticking)
})

const handleScroll = () => {
    if (!props.mobileVisibilityThreshold || rootElementPosition === null) return

    const isScrollUp = previousScrollY > window.scrollY
    const isScrollBelowThreshold = window.scrollY - rootElementPosition > props.mobileVisibilityThreshold

    if (isScrollUp) {
        isVisible.value = true
    } else if (isScrollBelowThreshold) {
        isVisible.value = false
    }

    previousScrollY = window.scrollY
}

onMounted(() => {
    if (!rootElement.value) return

    const boundingClientRect = rootElement.value.getBoundingClientRect()

    rootElementPosition = boundingClientRect.top + window.scrollY

    const observer = new IntersectionObserver(
        ([e]) => {
            isSticking.value = e.intersectionRatio < 1
        },
        { threshold: [1] },
    )

    observer.observe(rootElement.value)

    watch(
        isScreenM,
        (isScreenM) => {
            if (isScreenM) {
                window.removeEventListener('scroll', handleScroll)
            } else {
                window.addEventListener('scroll', handleScroll)
            }
        },
        { immediate: true },
    )

    onUnmounted(() => {
        observer.disconnect()
        window.removeEventListener('scroll', handleScroll)
    })
})
</script>
